// extracted by mini-css-extract-plugin
var _1 = "EpostValidationErrorsTable-modulecell__KOqNS TableHeaderRowCell-moduleTableHeaderRowCell__zrJys";
var _2 = "EpostValidationErrorsTable-modulerow__bfHpV TableComponent-modulerow__xPAo4";
var _3 = "EpostValidationErrorsTable-moduletable__yY8Jt TableComponent-moduleTable__mhqNq";
export { _1 as "cell", _2 as "row", _3 as "table" }
